export default {
  props: ["index"],
  data() {
    return {
      cartNum: 0
    };
  },
  methods: {},
  mounted() {}
};